export default __webpack_public_path__ + "static/media/groupcoachinggrid.6082b375.svg";